import ObjectCopyService from "external-services/object-copy-service/index";
import {Environment} from "appRoot/app.constants";
import NetworkConnectionService from 'external-services/network-connection-service/index';
import TrackingService from 'app/services/tracking/tracking.service';
import AdminService from "external-services/diary-admin-service/admin.service";
import ManagerService from "external-services/manager-service/manager.service";
import PhoneNumberService from 'external-services/phone-number-service/index';
import {phoneNumberTypes} from 'external-services/phone-number-service/phoneNumber.types';
import CustomerUpdateService from "external-services/customer-update-service/customerUpdate.service";
import CustomerService from "app/services/customer/customer.service";
import { cloneDeep } from "lodash-es";
import BookingLookupService from "external-services/booking-lookup-service/index";
import SimpleDialogActions from 'app/actions/simpleDialog.actions';
import CustomerLookupService from 'external-services/customer-lookup-service';

const NS = 'EditCustomer'; // jshint ignore:line

export default function EditCustomer(
  $scope, $mdDialog, $timeout, $filter, customer, isOffline, handleNewCustomerSelected,
  unregister, isTouchDevice, AuthService
) {
  "ngInject";

  const vm = this;
  TrackingService.trackPageView('cusromer.edit');
  const UPPER_LIMIT = 10000;
  vm.DEFAULT_LIMIT = 10;

  vm.limitBookingsTo = vm.DEFAULT_LIMIT;

  vm.debug = Environment.IsLocal;
  vm.isManager = ManagerService.isManager;
  vm.online = NetworkConnectionService.isOnline();
  vm.customer = ObjectCopyService.angularSafeCopy(customer);
  const customerCopy = ObjectCopyService.angularSafeCopy(customer);
  vm.customerValid = true;
  vm.isEditCustomer = true;
  vm.isOffline = isOffline;
  vm.permanentTags = vm.customer.tags.filter(t => t.permanent);
  vm.displayErrors = false;
  vm.venue = AdminService.getVenue();
  // states
  vm.LOADING = 1;
  vm.ENTER = 0;
  vm.SUCCESS = 2;
  vm.CONFIRM = 3;
  vm.DELETED = 4;
  vm.ERROR = 5;
  vm.OFFLINE = 8;
  vm.state = vm.ENTER;
  vm.errorMessage = null;

  // methods
  vm.cancel = cancel;
  vm.save = save;
  vm.checkForSave = checkForSave;
  vm.remove = remove;
  vm.cancelRemove = cancelRemove;
  vm.confirmRemove = confirmRemove;
  vm.ok = ok;
  vm.loadMoreHistoricalBookings = loadMoreHistoricalBookings;

  //-- listen
  var listeners = [];
  window.addEventListener('online', updateOnlineStatus);
  window.addEventListener('offline', updateOnlineStatus);
  listeners.push($scope.$on('$destroy', () => {
    unregister(listeners);
    window.removeEventListener('online', updateOnlineStatus);
    window.removeEventListener('offline', updateOnlineStatus);
  }));
  if (window.config.phoneValidation) {
    listeners.push($scope.$watch('vm.customer.phone', formatPhone));
  }

  // init
  if (!isTouchDevice) {
    vm.showComplete = true;
  }

  // check couch
  if (NetworkConnectionService.isOnline()) {
    AdminService.restartPeriodicCouchNameCheck(); // restarts the timer
    AdminService.loadVenue(vm.venue.id, true, true).catch(function (err) {
      console.error(err);
      AuthService.checkAuth().then((res) => {
        if (!res) {
          $mdDialog.cancel();
        }
      });
    });
  }

  getCustomerHistory();
  getVenueVisitHistory();
  formatPhone(vm.customer.phone);

  function updateOnlineStatus() {
    vm.online = NetworkConnectionService.isOnline();
  }

  function cancel() {
    $mdDialog.hide();
  }

  function showEditCustomerConfirmation() {
    var tempCustomer = cloneDeep(vm.customer);
    tempCustomer = PhoneNumberService.resetPhoneNumberWithTypeValidation(tempCustomer); // Remove country prefix when national number contains special char and a~z A~Z

    // const diffInfoList = CustomerService.checkDifference(customerCopy, vm.customer);
    const diffInfoList = CustomerService.checkDifference(customerCopy, tempCustomer);
    const dialogMessage = `You are about to update an existing customer record, would you like to proceed? <div>Current Details: ${customerCopy.fullName || ''} ${customerCopy.phone && customerCopy.phone.trim() != '' ? `(${customerCopy.phone})` : ''} ${customerCopy.email || ''} </div`;
    const headerMsg = 'Save confirmation';
    SimpleDialogActions.showDialog({
      description: dialogMessage,
      title: headerMsg,
      confirmText: 'Continue',
      rejectText: 'Cancel',
      handleConfirm: () => {
        SimpleDialogActions.hideDialog();
        save();
      },
      handleReject: () => {
        SimpleDialogActions.hideDialog();
      },
      diffInfoList,
      dialogSize: 'md'
    });
  }

  function checkForSave() {
    if(vm.customer._id && vm.customer._rev && vm.customer.edited) {
      showEditCustomerConfirmation();
    }
    else {
      save();
    }
  }

  function save() {
    var tempCustomer = ObjectCopyService.angularSafeCopy(vm.customer);
    tempCustomer = PhoneNumberService.resetPhoneNumberWithTypeValidation(tempCustomer); // Remove country prefix when national number contains special char and a~z A~Z

    vm.displayErrors = !vm.customerValid;
    if (vm.displayErrors) {
      return;
    }

    vm.state = vm.LOADING;
    // CustomerUpdateService.update(vm.customer).then(function () {
    CustomerUpdateService.update(tempCustomer).then(function () {
      vm.customer.edited = false;
      vm.state = vm.SUCCESS;
      if (handleNewCustomerSelected) {
        handleNewCustomerSelected(tempCustomer);
      }
      $timeout(function () {
        $mdDialog.hide();
      }, 1500);
    }).catch(() => {
      vm.state = vm.ERROR;
      vm.errorMessage = 'Customer update failed';
    });
  }

  function getCustomerHistory() {
    // get customer history
    vm.customerHistoryLoading = true;
    if (vm.customer._id) {
      var ids = vm.customer ? (vm.customer.venueIds || []).concat(vm.customer._id) : [vm.booking.customerId];
      BookingLookupService.getBookingsByCustomerIds(ids, true).then(customerBookings => {
        vm.customerBookings = $filter('orderBy')(customerBookings, 'time', true);
        vm.customerHistoryLoading = false;
      }).catch(() => {
        vm.customerBookings = false;
        vm.customerHistoryLoading = false;
      });
    } else {
      vm.customerBookings = [];
      vm.customerHistoryLoading = false;
    }
  }

  function getVenueVisitHistory() {
    if (NetworkConnectionService.isOnline()) {
      vm.venueVisitHistoryLoading = true;
      if (vm.customer._id) {
        CustomerLookupService.getVenueVisitHistory(vm.customer._id).then(venueVisitHistory => {
          vm.venueVisitHistory = venueVisitHistory;
          vm.venueVisitHistoryLoading = false;
        }).catch(function () {
          vm.venueVisitHistory = false;
          vm.venueVisitHistoryLoading = false;
        });
      } else {
        vm.venueVisitHistory = [];
        vm.venueVisitHistoryLoading = false;
      }
    }
  }

  function remove() {
    if (NetworkConnectionService.isOnline()) {
      vm.state = vm.LOADING;
      BookingLookupService.getBookingsByCustomerIds((vm.customer.venueIds || []).concat(vm.customer._id), true).then(function (bookings) {
        vm.bookings = bookings;
        vm.state = vm.CONFIRM;
      });
    } else {
      vm.state = vm.OFFLINE;
    }
  }

  function cancelRemove() {
    vm.state = vm.ENTER;
  }

  function confirmRemove() {
    if (NetworkConnectionService.isOnline()) {
      vm.state = vm.LOADING;
      CustomerUpdateService.remove(vm.customer).then(() => {
        vm.state = vm.DELETED;
        $timeout(() => {
          $mdDialog.hide();
        }, 1500);
      }).catch(() => {
        vm.errorMessage = 'Customer delete failed';
        vm.state = vm.ERROR;
      });
    } else {
      vm.state = vm.OFFLINE;
    }
  }

  function ok() {
    vm.state = vm.ENTER;
  }

  function formatPhone(phoneNumber) {
    // var formattedPhone = PhoneNumberService.normalizePhoneNumber(phoneNumber, INTERNATIONAL);
    var formattedPhone = PhoneNumberService.normalizePhoneNumber(phoneNumber, phoneNumberTypes.INTERNATIONAL, AdminService.getVenue());
    if (formattedPhone) {
      vm.customer.phone = formattedPhone;
      vm.isPhoneValid = true;
    } else {
      vm.isPhoneValid = false;
    }
  }

  function loadMoreHistoricalBookings() {
    vm.limitBookingsTo = UPPER_LIMIT;
  }
}
